import axios from 'axios';
import $http from './ajax';
import { getUrlParam, getCookie } from '../js/utils';
import { log } from '../native-interact/EventEmmiter';

const DEBUG = false;

// 开发环境上传地址
const logDevUrl = '/GeomagnetismSystem/frankLog/logSave.do';
// const logTestUrl = 'http://saasdemopre.parking24.cn/GeomagnetismSystem/frankLog/logSave.do';
// const logProUrl = 'http://saasdemopre.parking24.cn/GeomagnetismSystem/frankLog/logSave.do';

// frank管理平台后台的ajax请求统一配置
const frankManagerConfig = {
  baseUrl: '/FrankManager',
  httpConfig: {
    statusKey: 'errno',
    statusValue: '200',
    msgKey: 'errtext',
    dataKey: 'data'
  }
};

// frank管理平台后台接口post请求
function postFrankManager(url, data, config = {}) {
  return $http.post(
    `${frankManagerConfig.baseUrl}${url}?UID=${getUrlParam('UID')}`,
    {
      ver: '1.0',
      data
    },
    Object.assign({}, frankManagerConfig.httpConfig, config)
  );
}

function getFrankManager(url) {
  return $http.get(
    `${frankManagerConfig.baseUrl}${url}?UID=${getUrlParam('UID')}`,
    frankManagerConfig.httpConfig
  );
}

/**
 * @description 上报日志
 * @export
 * @param {object} data
 * @returns
 */
export function postLog(data) {
  return $http.post(
    logDevUrl,
    data,
    {
      statusKey: 'message.code',
      statusValue: '200',
      msgKey: 'message.message',
      dataKey: 'data',
      toastError: false
    }
  );
}

export function saveDebugLog(data) {
  return postFrankManager(
    '/geoActivate/saveDebugLog',
    data
  );
}

/**
 * @description 获取当前用户信息
 * showdoc: http://192.168.10.114:5000/showdoc/index.php?s=/17&page_id=482
 * @export
 * @returns
 */
export function getUserInfo() {
  return $http.post(
    '/FrankManager/sysparam/checkAuthority.do',
    { UID: getUrlParam('UID') },
    {
      statusKey: 'message.errorCode',
      statusValue: '200',
      msgKey: 'message.errorDsc',
      dataKey: 'resultObj',
      toastError: false
    }
  );
}

/**
 * @description 获取当前用户权限范围内的所有停车场
 * @export
 * @returns
 */
export function getParkList() {
  // return Promise.resolve([
  //   {
  //     id: 1,
  //     name: '测试停车场',
  //     address: '杭州'
  //   },
  //   {
  //     id: 2,
  //     name: 'test',
  //     address: '杭州'
  //   },
  //   {
  //     id: 3,
  //     name: '嘻嘻',
  //     address: '杭州'
  //   }
  // ]);
  return postFrankManager(
    '/parkinglot/getAllList.do'
  );
}

/**
 * @description 发送语音到后台 后台请求讯飞API回传识别后的语音结果
 * @export
 * @param {FormData}} 语音文件
 * @returns
 */
export function getAuidoTxt(url) {
  const audioForm = new FormData();
}

/**
 * @description 获取服务器时间
 * @export
 * @param {FormData}} 不用传参
 * @returns
 */
export function getServeTime() {
  const url = '/parking/getLocalTime.do';
  return $http.get(
    `${frankManagerConfig.baseUrl}${url}?UID=${getUrlParam('UID')}`,
    frankManagerConfig.httpConfig
  );
}

/**
 * @description 根据mac获取车位信息
 * @export
 * @param {string} mac 地磁序列号
 * @returns
 */
export function getParkingSpaceByMac(mac, config) {
  if (DEBUG) {
    return postFrankManager(
      '/sysparam/getParking.do',
      {
        serial: '000000'
      }
    );
  }
  return postFrankManager(
    '/sysparam/getParking.do',
    {
      serial: mac
    },
    config
  );
}

/**
 * @description 获取阿里云配置
 * @export
 */
export function getOSS() {
  return getFrankManager('/sysparam/getOss.do').then((res) => {
    log.post({
      log_content: `操作：获取阿里云配置；状态：成功；接收：${JSON.stringify(res)}`,
      raw_content: '操作：获取阿里云配置；'
    }, true);
    return Promise.resolve(res);
  }).catch((error) => {
    log.post({
      log_content: `操作：获取阿里云配置；状态：失败；；接收：${JSON.stringify(error)}；`,
      raw_content: '操作：获取阿里云配置；状态：'
    }, false);
    return Promise.reject(error);
  });
}

/**
 * @description 获取地磁对应项目参数
 * @param {object} serial 查询参数
 * @returns
*/
export function getSerial(serial) {
  return postFrankManager(
    '/geom/getGeoByParkingnoOrSerial.do',
    serial
  );
}

/**
 * @description 获取项目夜间模式配置
 * @param {object} data 查询参数
 * @returns
*/
export function getNightMode(data) {
  return postFrankManager(
    '/projectCommand/getOne.do',
    data
  );
}

/**
 * @description 设置项目夜间模式
 * @param {object} data 设置参数
 * @returns
*/
export function setNightMode(data) {
  return postFrankManager(
    `/projectCommand/modify.do?UID=${getUrlParam('UID')}`,
    data
  );
}

/**
 * @description 获取地磁升级信息
 * @export
 * @param {string} devType // 设备类型
 * @returns
 */
export function getUpgradeInfo(devType, firmwaretype, custom) {
  return postFrankManager(
    '/upgrade/getUpgrade.do',
    {
      devtype: devType,
      firmwaretype,
      toastError: !!custom
    }
  );
}

/**
 * @description 保存地磁和车位的信息
 * @export
 * @param {object} data
 * @returns
 */
export function submitParkingspaceData(data) {
  return postFrankManager(
    '/parking/add.do',
    data,
    { toastError: false }
  ).then((res) => {
    log.post({
      log_content: `操作：上传车位数据；状态：成功；发送：${JSON.stringify(data)}；接收：${JSON.stringify(res)}`,
      raw_content: `操作：上传车位数据；状态：成功；发送：${JSON.stringify(data)}；接收：${JSON.stringify(res)}`
    }, true);
    return Promise.resolve(res);
  }).catch((error) => {
    log.post({
      log_content: `操作：上传车位数据；状态：失败；发送：${JSON.stringify(data)}；接收：${JSON.stringify(error)}`,
      raw_content: `操作：上传车位数据；状态：失败；发送：${JSON.stringify(data)}；接收：${JSON.stringify(error)}`
    }, false);
    return Promise.reject(error);
  });
}

// 上传组装后每一步安装调试的数据
export function sendResult(data) {
  return postFrankManager(
    '/log/addOperateLog.do',
    {
      UID: getUrlParam('UID'),
      ...data
    }
  );
}

// 上传安装调试结束后调用过程
export function postCallAction(data) {
  log.post({
    log_content: `操作：${data}`,
    raw_content: '调用栈'
  }, true);
}

/**
 * @description 保存地磁和车位的信息(当前车位已绑定，强制取消绑定)
 * @export
 * @param {object} data
 * @returns
 */
export function submitParkingspaceDataForce(data, oldParkingno) {
  return postFrankManager(
    '/parking/coverParking.do',
    data
  ).then((res) => {
    log.post({
      log_content: `操作：将地磁${data.serial}的车位号从${oldParkingno}更改为${data.parkingno}；状态：成功；发送：${JSON.stringify(data)}；接收：${JSON.stringify(res)}`,
      raw_content: `操作：将地磁${data.serial}的车位号从${oldParkingno}更改为${data.parkingno}；状态：成功；发送：${JSON.stringify(data)}；接收：${JSON.stringify(res)}`
    }, true);
    return Promise.resolve(res);
  }).catch((error) => {
    log.post({
      log_content: `操作：将地磁${data.serial}的车位号从${oldParkingno}更改为${data.parkingno}；状态：失败；发送：${JSON.stringify(data)}；接收：${JSON.stringify(error)}`,
      raw_content: `操作：将地磁${data.serial}的车位号从${oldParkingno}更改为${data.parkingno}；状态：失败；发送：${JSON.stringify(data)}；接收：${JSON.stringify(error)}`
    }, false);
    return Promise.reject(error);
  });
}

export function getAutomatorConfig(pageType) {
  return postFrankManager('/sysparam/getDebugPath.do', {})
    .then((data) => {
      // 根据页面类型 返回不同调试脚本
      const jsonData = pageType === 'index' ? data.install : data.fix;
      return axios.get(jsonData).then((res) => {
        if (res.status === 200) {
          return res.data;
        }

        return [];
      });
    });
}

export function getAutomatorAllConfig() {
  return postFrankManager('/sysparam/getDebugPath.do', {})
    .then((data) => {
      return axios.get(data.all).then((res) => {
        if (res.status === 200) {
          return res.data;
        }

        return [];
      });
    });
}

export function getAutoConfigOrder(version) {
  return postFrankManager('/version/commandList.do', {
    version: Number(version)
  });
}

export function getAutomatorConfigFix() {
  return postFrankManager('/sysparam/getDebugPath.do', {})
    .then((data) => {
      return axios.get(data.fix).then((res) => {
        if (res.status === 200) {
          return res.data;
        }

        return [];
      });
    });
}

// 获取图形验证码地址
const IMG_CODE_URL = `${frankManagerConfig.baseUrl}/pub/app/sms/get_equation_verify_code.do`;
export function getImgCodeUrl() {
  return `${IMG_CODE_URL}?random=${Math.random()}`;
}

// 发送短信验证码
export function sendSmsCode(phone, imgCode) {
  return postFrankManager(
    '/pub/app/sms/sendEquationCode.do',
    {
      phone,
      equation_result: imgCode,
      random_reformer: getCookie('random_reformer')
    }
  );
}

// 验证短信验证码
export function verifySmsCode(phone, smsCode) {
  return postFrankManager(
    '/account/phonelogin.do',
    {
      phone,
      smsCode
    }
  );
}

// 更新项目列表
export function updateProjectList() {
  return postFrankManager(
    '/project/getList.do',
    {}
  );
}

// 上传地磁检测到的车位变化
export function updateParkingspaceState(data) {
  return $http.post(
    '/NBGeoServer/ParkingSpace/manualpark.do',
    data,
    {
      statusKey: 'errno',
      statusValue: '200',
      msgKey: 'errtext',
      dataKey: 'data',
      toastError: false
    }
  );
}

// 获取模糊匹配控制器列表
export function getFuzzyMatchedMeter(val) {
  // TODO 更改为正式接口
  return Promise.resolve([
    {
      no: '888001',
      parkingname: '测试停车场'
    },
    {
      no: '888002',
      parkingname: '测试停车场'
    },
    {
      no: '888003',
      parkingname: '测试停车场'
    },
    {
      no: '888004',
      parkingname: '测试停车场'
    }
  ]);
  // return postFrankManager(
  //   '/meter/getList.do',
  //   {
  //     data: val
  //   }
  // );
}


/**
 * 获取生产测试的雷达基值
 *
 * @export
 * @param {string} mac
 * @return {Array}
 */
export function getProRadarBase(mac) {
  return $http.post(
    '/GeomagnetismSystem/frankLog/queryLog.do',
    {
      mac,
      log_type: '1',
      log_content: 'init radar',
      pageSize: 10,
      curPage: 1,
      parking_space: '',
      frank_status: '10'
    },
    {
      statusKey: 'message.code',
      statusValue: '200',
      msgKey: 'message.message',
      dataKey: 'data',
      toastError: false
    }
  ).then((res) => {
    console.log('生产日志数据：', res);
    if (res && Array.isArray(res) && res.length > 0) {
      for (let index = 0; index < res.length; index++) {
        const logData = res[index].log_content;
        const base = logData.match(/\{[\d\s]*\}/);
        if (base && base.length > 0) {
          const values = base[0].replace(/{|}/g, '').split(/\s+/);

          log.postSuccess({
            operate: '获取生产雷达基值',
            receive: `{${values.join(' ')}}`,
            receiveOrigin: logData,
            count: 1,
          });

          console.log('生产雷达基值：', JSON.stringify(values));
          return values;
        }
      }
      return [];
    }
    return [];
  });
}
